import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import Modal from "common/components/Modal/Modal"
import useRealTimeCerficiation from "common/hooks/useRealTimeCertification"
import VerificarEmpresaNotification from "features/User/forms/PerfilEmpresa/VerificarEmpresaNotification"
import { MODES_MODAL_VARIFICACION } from "features/User/forms/PerfilEmpresa/VerificarEmpresaNotification/constant"
import { userValidateValidations } from "features/User/redux/slices/userSlice"
import {
  certificadoEmpresaValidacion,
  certificadoInvalidCertficiado,
  certificadoValidationSelector,
} from "features/Validaciones/redux/selectors/validationsSelector"
import {
  setShowModalEmpresaCertificado,
  setShowModalInvalidCertificado,
} from "features/Validaciones/redux/slices/validationsSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { ReactNode, useEffect } from "react"
import { Trans } from "react-i18next"
import certificadoElectronico from "../../../../assets/certificado-electronico.svg"

const SecondaryValidacion = ({
  children,
  section,
}: {
  children: ReactNode
  section: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}): ReactNode => {
  const showTable = useSelector(certificadoValidationSelector)
  const { activeCompany } = useUsuarioEmpresaActiva()

  const { setOpen, isOn } = useRealTimeCerficiation()

  const dispatch = useDispatch()

  const handleValidation = async () => {
    setOpen(true)
  }

  useEffect(() => {
    isOn && dispatch(userValidateValidations())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isOn])

  const showCertificadoEmpresaValidacion = useSelector(
    certificadoEmpresaValidacion
  )
  const showCertificadoInvalidCertficiado = useSelector(
    certificadoInvalidCertficiado
  )

  const handleCloseValidateEmpresaModal = () => {
    dispatch(setShowModalEmpresaCertificado(false))
  }
  const handleCloseValidateInvalidoModal = () => {
    dispatch(setShowModalInvalidCertificado(false))
  }
  return (
    <div>
      {!showTable ? (
        <div className='tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center'>
          <div className='tw-w-[500px] tw-h-auto tw-flex tw-flex-col tw-my-20'>
            <div className='tw-h-44 tw-flex tw-justify-center'>
              <div className='tw-w-52 tw-h-auto tw-flex tw-justify-center tw-items-center'>
                <img
                  src={certificadoElectronico}
                  alt='autorizacion logo'
                  className='tw-mb-4'
                />
              </div>
            </div>
            <div className='tw-h-64 tw-flex tw-flex-col tw-justify-center tw-items-center'>
              <span>
                <Trans i18nKey='validaciones.validar.title' />
              </span>
              <span className='tw-mb-3'>
                <Trans i18nKey='validaciones.validar.textOne' />
                {section}
                <Trans i18nKey='validaciones.validar.textTwo' />
              </span>
              <span className='tw-mb-6'>
                <Trans i18nKey='validaciones.validar.textThree' />
                <span className='tw-font-bold'>
                  <Trans i18nKey='validaciones.validar.textFour' />
                </span>{" "}
                <Trans i18nKey='validaciones.validar.textFive' />
                <a
                  className='tw-underline tw-text-info'
                  href='https://www.accv.es/necesitas-ayuda/'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <Trans i18nKey='validaciones.validar.textSix' />
                </a>
              </span>
              <button
                className='!tw-bg-primary tw-text-simple-10 tw-rounded tw-w-44 tw-h-12'
                type='button'
                onClick={handleValidation}
              >
                <Trans i18nKey='validaciones.validar.openCert' />
              </button>
            </div>
          </div>
        </div>
      ) : (
        children
      )}
      <Modal
        onHide={handleCloseValidateEmpresaModal}
        visible={showCertificadoEmpresaValidacion}
        className='!tw-w-[448px] tw-rounded-lg'
        closable={false}
        showHeader={false}
        breakpoints={undefined}
        contentClassName='!tw-p-0 !tw-rounded-lg'
        header={undefined}
      >
        <VerificarEmpresaNotification
          empresaActivaRazonSocial={activeCompany.razonSocial}
          onHide={handleCloseValidateEmpresaModal}
          onSubmit={handleCloseValidateEmpresaModal}
          mode={MODES_MODAL_VARIFICACION.ERROR}
          errorInfo={undefined}
        />
      </Modal>
      <Modal
        onHide={handleCloseValidateInvalidoModal}
        visible={showCertificadoInvalidCertficiado}
        className='!tw-w-[448px] tw-rounded-lg'
        closable={false}
        showHeader={false}
        breakpoints={undefined}
        contentClassName='!tw-p-0 !tw-rounded-lg'
        header={undefined}
      >
        <VerificarEmpresaNotification
          empresaActivaRazonSocial={activeCompany.razonSocial}
          onHide={handleCloseValidateInvalidoModal}
          onSubmit={handleCloseValidateInvalidoModal}
          mode={MODES_MODAL_VARIFICACION.ERROR}
          errorInfo={
            <div>
              <Trans i18nKey='validaciones.validar.errorTextOne'>
                {{ nif: activeCompany.nif }}
              </Trans>
              {activeCompany.nif}
              <Trans i18nKey='validaciones.validar.errorTextTwo' />
            </div>
          }
        />
      </Modal>
    </div>
  )
}

export default SecondaryValidacion
